import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { environment } from '../../../environments/environment';
import { HttpTransportType, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { MessageModel } from '../interfaces/chat.interface';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserSessionStorageService } from './user-sessions.service';

@Injectable({ providedIn: 'root' })
export class SignalRService {

  constructor(private http: HttpClient, private sessionService: UserSessionStorageService) {
  }

  public connection?: signalR.HubConnection;

  private sending$ = new BehaviorSubject<boolean>(false);
  public sending = this.sending$.asObservable();

  private apiUrl = `${environment.apiUrl}/Chat`;

  public recievedMessage: MessageModel = {
    token: "",
    content: "",
    role: "assistant",
    time: new Date(),
    dataSourceId: 0
  };

  private getAuthHeaders() {
    const token = this.sessionService.getItem('access_token'); // Получаем токен из sessionStorage
    return new HttpHeaders({
      'Authorization': `Bearer ${token}`, // Добавляем токен в заголовок
    });
  }

  public async connect(token: string) {
    try {

      this.connection = new HubConnectionBuilder()
        .withUrl(`${environment.hubUrl}`, {
          accessTokenFactory: () => token,
          transport: HttpTransportType.WebSockets,
          skipNegotiation: true,
          

        })
        .configureLogging(LogLevel.Critical)
        .withAutomaticReconnect()
        .build();


      this.connection.on("RecieveMessage", msg => {

        let message = {
          token: token,
          content: msg,
          role: "assistant",
          time: new Date(),
          dataSourceId: 0
        }

        this.recievedMessage = message;
    });

    await this.connection.start();

      console.log('SignalR connected');

    } catch (err) {
      console.error('SignalR connect error:', err);
      this.connection = undefined;
    }
  }

  public async sendMessage(currentDatasource: number, datasourceType: string, message: string) {
    if (!this.connection) {
      console.warn('No connection instance');
      return;
    }
    if (this.connection.state !== signalR.HubConnectionState.Connected) {
      console.warn('Connection not in Connected state:', this.connection.state);
      return;
    }
    try {
      this.sending$.next(true);

      await this.connection.invoke('SendMessage', currentDatasource, datasourceType, message);

      this.sending$.next(false);
    } catch (err) {
      console.error('SendMessage error:', err);
    }
  }

  getAllMessages(token: string): Observable<MessageModel[]> {
    let request = {
      token: token
    }

    return this.http.get<MessageModel[]>(`${this.apiUrl}/GetHistory`,
    {
      headers: this.getAuthHeaders(),
      params: request
    }
    );
  }

}

